// extracted by mini-css-extract-plugin
export var title = "page-title-module--title--3-FRx";
export var bg = "page-title-module--bg--DXowr";
export var h1 = "page-title-module--h1--2xk01";